import { useEffect, useState } from 'react'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { useFormik } from 'formik'
import { is } from 'immutable';
import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';
import { Auth } from 'aws-amplify';
import axios from 'axios';
import { useAuth } from '../../../../../modules/auth';



const API_URL_API = process.env.REACT_APP_API_URL_BACKEND + ''

type Props = {
    toggleShow: any,
    isUpdate: boolean,
    itemToEdit: any,
    roles: any,
}

const UserAddModal: React.FC<Props> = ({ toggleShow, isUpdate, roles, itemToEdit }) => {

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState(isUpdate ? itemToEdit : { 'id': '0', 'first_name': '', 'last_name': '', 'email': '', 'password': '', 'role_id': 1 });

    const [errFirstName, setErrFirstName] = useState(false)
    const [errLastName, setErrLastName] = useState(false)
    const [errEmail, setErrEmail] = useState(false)
    const [errEmailFormat, setErrEmailFormat] = useState(false)
    const [errPassword, setErrPassword] = useState(false)
    const [errPasswordMin, setErrPasswordMin] = useState(false)
    const [showError, setShowError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [showOrg, setShowOrg] = useState(false);
    const [showBranch, setShowBranch] = useState(false);
    const [showDeptt, setShowDeptt] = useState(false);
    const [loadingOrg, setLoadingOrg] = useState(false);
    const [loadingBranch, setLoadingBranch] = useState(false);
    const [loadingDeptt, setLoadingDeptt] = useState(false);
    const [selectedOrg, setSelectredOrg] = useState(0);
    const [selectedBranch, setSelectredBranch] = useState(0);
    const [selectedDeptt, setSelectredDeptt] = useState(0);
    const [organizations, setOrganizations] = useState([]);
    const [branches, setBranches] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [selectedRole, setSelectedRole] = useState(0);
    const {currentUser} = useAuth();

    useEffect(() => {
        document.body.classList.add('modal-open')

        const role_id = currentUser.userSession.user.role_id;
        if (role_id == 2) {
            setLoadingOrg(true);
            setShowOrg(true);
            setShowBranch(false);
            getAllOrganizations()
        } else if(role_id == 3) {

            setLoadingBranch(true);
            setLoadingDeptt(true);
            setShowBranch(true);
            setShowDeptt(true);
            getBranchDeptt(currentUser.userSession.user.branch_id)
        } 


        return () => {
            document.body.classList.remove('modal-open')
        }

    }, [])

    const handleSubmit = async (e: any) => {

        e.preventDefault();
        setIsSubmitting(true);
        setErrFirstName(false);
        setErrLastName(false);
        setErrEmail(false);
        setErrEmailFormat(false);
        setErrPassword(false);
        setErrPasswordMin(false);
        setShowError(false);

        var errFound = false;

        if (formData.first_name.trim() == '') {
            errFound = true;
            setErrFirstName(true);
        }

        if (formData.last_name.trim() == '') {
            errFound = true;
            setErrLastName(true);
        }

        const auth = await Auth.currentSession();
        const token = auth.getAccessToken().getJwtToken();
        try {



            if (!isUpdate) {
                // create process

                if (formData.email.trim() == '') {
                    errFound = true;
                    setErrEmail(true);
                } else if (!checkEmailValidation(formData.email)) {
                    errFound = true;
                    setErrEmailFormat(true);
                }

                if (formData.password.trim() == '') {
                    errFound = true;
                    setErrPassword(true);
                } else if (!checkPasswordStrenght(formData.password)) {
                    errFound = true;
                    setErrPasswordMin(true);
                }

                if (errFound) {
                    setIsSubmitting(false);
                    return;
                }

                const fullname = formData.first_name + ' ' + formData.last_name;

                formData['organization_id'] = selectedOrg;
                formData['branch_id'] = selectedBranch;
                formData['department_id'] = selectedDeptt;

                const { user, userSub } = await Auth.signUp({
                    username: formData.email,
                    password: formData.password,
                    attributes: {
                        email: formData.email,
                        name: fullname,
                        'custom:byadmin': 'true'
                    },
                    autoSignIn: {
                        enabled: false,
                    }
                });

                formData['sub'] = userSub;

                await fetch(API_URL_API + '/admin/user/create',
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                        body: JSON.stringify(formData),
                    });
            }
            else {
                // update process

                if (errFound) {
                    setIsSubmitting(false);
                    return;
                }

                formData["user_id"] = formData.id; //have to add user_id, because form input name was not affecting post value name

                await fetch(API_URL_API + '/admin/user/update',
                    {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                        body: JSON.stringify(formData),
                    });
            }


            toggleShow();
        }
        catch (error: any) {
            const { code, message } = error;

            if (code == 'UsernameExistsException') {
                setErrMsg(message);
            } else {
                setErrMsg(message);
            }

            setShowError(true)

            setIsSubmitting(false);
        }
    };

    const handleChange = (e: any) => {

        setFormData(
            {
                ...formData,
                [e.target.name]: e.target.value
            }
        );

    };

    const handleChangeRole = (e: any) => {
        const role_id = e.target.value;
        setFormData(
            {
                ...formData,
                ['role_id']: role_id
            }
        );

        setSelectedRole(role_id)

        if (role_id == 2) {
            setLoadingOrg(true);
            setShowOrg(true);
            setShowBranch(false);
            getAllOrganizations()
        } else if(role_id == 3) {
            if(currentUser.userSession.user.role_id < 3){
                setLoadingOrg(true);
                setShowOrg(true);
            }
            setLoadingBranch(true);
            setShowBranch(true);
            setShowDeptt(false);
            getDataForRole3()
        } else if(role_id == 4 || role_id == 5) {
            if(currentUser.userSession.user.role_id < 3){
                setLoadingOrg(true);
                setShowOrg(true);
            }
            if(currentUser.userSession.user.role_id == 3){
                setLoadingBranch(true);
                setShowBranch(true);
            }

            setLoadingDeptt(true);
            setShowDeptt(true);
            getDataForRole4()
        } else {
            
            setShowOrg(false);
            setShowBranch(false);
            setShowDeptt(false);
        }
    }

    const handleChangeOrg = (e: any) => {
        const org_id = e.target.value;
        setFormData(
            {
                ...formData,
                ['organization_id']: org_id
            }
        );

        setSelectredOrg(org_id);
        setLoadingBranch(true)
        setLoadingDeptt(true)
        getBranchDeptt(org_id)

    }


    const getBranchDeptt = async (org_id: any) => {
        try {
            const auth = await Auth.currentSession();
            const token = auth.getAccessToken().getJwtToken();

            const { data: result } = await axios.get(`${API_URL_API}/getBranchDeptt/${org_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setBranches(result.data.branches)
            setSelectredBranch(result.data.branches[0].id)
            setLoadingBranch(false);
            setDepartments(result.data.departments)
            setSelectredDeptt(result.data.departments[0].id)
            setLoadingDeptt(false);
        } catch (err) {
            console.log(err)
        }
    }

    const handleChangeBranch = (e: any) => {
        const branch_id = e.target.value;
        setFormData(
            {
                ...formData,
                ['branch_id']: branch_id
            }
        );

        setSelectredBranch(branch_id);
        setLoadingDeptt(true)
        getDepttAdmin(branch_id)

    }


    const getDepttAdmin = async (branch_id: any) => {
        try {
            const auth = await Auth.currentSession();
            const token = auth.getAccessToken().getJwtToken();

            const { data: result } = await axios.get(`${API_URL_API}/getDepttAdmin/${branch_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setDepartments(result.data)
            setSelectredDeptt(result.data[0].id)
            setLoadingDeptt(false);
        } catch (err) {
            console.log(err)
        }
    }


    const getDataForRole3 = async () => {
        try {
            const auth = await Auth.currentSession();
            const token = auth.getAccessToken().getJwtToken();

            const { data: result } = await axios.get(`${API_URL_API}/getDataForRole3`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setSelectredOrg(result.data.organizations[0].id)
            setOrganizations(result.data.organizations);
            setBranches(result.data.branches)
            setSelectredBranch(result.data.branches[0].id)
            setLoadingOrg(false);
            setLoadingBranch(false);
        } catch (err) {
            console.log(err)
        }
    }

    const getDataForRole4 = async () => {
        try {
            const auth = await Auth.currentSession();
            const token = auth.getAccessToken().getJwtToken();

            const { data: result } = await axios.get(`${API_URL_API}/getDataForRole4`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setOrganizations(result.data.organizations);
            setBranches(result.data.branches)
            setDepartments(result.data.departments)
            setSelectredOrg(result.data.organizations[0].id)
            setSelectredBranch(result.data.branches[0].id)
            setSelectredDeptt(result.data.departments[0].id)
            setLoadingOrg(false);
            setLoadingBranch(false);
            setLoadingDeptt(false);

        } catch (err) {
            console.log(err)
        }
    }


    const getAllOrganizations = async () => {

        try {
            const auth = await Auth.currentSession();
            const token = auth.getAccessToken().getJwtToken();

            const { data: result } = await axios.get(`${API_URL_API}/organization`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setOrganizations(result.data);
            setSelectredOrg(result.data[0].id)
            setLoadingOrg(false);

        } catch (err) {
            console.log(err)
        }
    }


    const checkEmailValidation = (email: string) => {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
    }

    const checkPasswordStrenght = (email: string) => {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=]).{8,}$/.test(email)
    }


    return (
        <>
            <div
                className='modal fade show d-block'
                id='kt_modal_add_user'
                role='dialog'
                tabIndex={-1}
                aria-modal='true'>
                <form id='kt_modal_add_user_form' onSubmit={handleSubmit} className='form' noValidate>
                    {/* begin::Modal dialog */}
                    <div className='modal-dialog modal-dialog-centered mw-650px'>
                        {/* begin::Modal content */}
                        <div className='modal-content'>
                            {/* <UserEditModalHeader /> */}
                            <div className='modal-header'>
                                {/* begin::Modal title */}
                                <h2 className='fw-bold'>
                                    {isUpdate ? 'Update User' : 'Add User'}
                                </h2>
                                {/* end::Modal title */}

                                {/* begin::Close */}
                                <div
                                    className='btn btn-icon btn-sm btn-active-icon-primary'
                                    data-kt-users-modal-action='close'
                                    onClick={toggleShow}
                                    style={{ cursor: 'pointer' }}>
                                    <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
                                </div>
                                {/* end::Close */}
                            </div>

                            {/* begin::Modal body */}
                            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                                {/* <UserEditModalFormWrapper /> */}

                                <div className='fv-row mb-7'>
                                    {/* hidden field is for id if the modal is open in Update mode */}

                                    <input type="hidden" name="user_id" value={formData ? formData.id : 0} onChange={handleChange} />

                                    <label className='required fw-semibold fs-6 mb-2'>First Name</label>
                                    <input
                                        type='text'
                                        name='first_name'
                                        className='form-control form-control-solid mb-3 mb-lg-0'
                                        autoComplete='off'
                                        onChange={handleChange}
                                        value={formData ? formData.first_name : ''}
                                    />
                                    {errFirstName ? <div className='form-text text-danger'>First Name is required.</div> : null}
                                </div>


                                <div className='fv-row mb-7'>
                                    {/* hidden field is for id if the modal is open in Update mode */}


                                    <label className='required fw-semibold fs-6 mb-2'>Last Name</label>
                                    <input
                                        type='text'
                                        name='last_name'
                                        className='form-control form-control-solid mb-3 mb-lg-0'
                                        autoComplete='off'
                                        onChange={handleChange}
                                        value={formData ? formData.last_name : ''}
                                    />
                                    {errLastName ? <div className='form-text text-danger'>Last name is required.</div> : null}
                                </div>

                                {
                                    !isUpdate ? (
                                        <div className='fv-row mb-7'>

                                            <label className='required fw-semibold fs-6 mb-2'>Email</label>
                                            <input
                                                type='email'
                                                name='email'
                                                className='form-control form-control-solid mb-3 mb-lg-0'
                                                autoComplete='off'
                                                onChange={handleChange}
                                                value={formData ? formData.email : ''}
                                            />
                                            {errEmail ? <div className='form-text text-danger'>Email is required.</div> : null}
                                            {errEmailFormat ? <div className='form-text text-danger'>Email is not valid.</div> : null}
                                        </div>
                                    ) : null
                                }

                                {
                                    !isUpdate ? (
                                        <div className='fv-row mb-7'>

                                            <label className='required fw-semibold fs-6 mb-2'>Password</label>
                                            <input
                                                type='password'
                                                name='password'
                                                className='form-control form-control-solid mb-3 mb-lg-0'
                                                autoComplete='off'
                                                onChange={handleChange}
                                                value={formData ? formData.password : ''}
                                            />
                                            {errPassword ? <div className='form-text text-danger'>Password is required.</div> : null}
                                            {errPasswordMin ? <div className='form-text text-danger'>Password is not strong.</div> : null}
                                            {<div className='form-text'>Minimum 8 characters, required 1 lower case 1 upper case and 1 special character.</div>}
                                        </div>
                                    ) : null
                                }


                                <div className='fv-row mb-7'>
                                    <label className='required fw-semibold fs-6 mb-2'>Role</label>
                                    <select onChange={handleChangeRole} defaultValue={formData.role_id ? formData.role_id : 1} name='role_id' className='form-select form-select-solid form-select-lg fw-semibold'>
                                        {
                                            roles.map((item: any) => <option key={item.id} value={item.id} >{item.name}</option>)
                                        }

                                    </select>
                                </div>

                                {
                                    showOrg ? loadingOrg ? (
                                        <div className='fv-row mb-7'>
                                            <div className='d-flex flex-center'>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='fv-row mb-7'>
                                            <label className='required fw-semibold fs-6 mb-2'>Organization</label>
                                            <select onChange={handleChangeOrg} defaultValue={selectedOrg} name='organization_id' className='form-select form-select-solid form-select-lg fw-semibold'>
                                                {
                                                    organizations.map((item: any) => <option key={item.id} value={item.id} >{item.name}</option>)
                                                }

                                            </select>
                                        </div>
                                    ) : null
                                }

                                {
                                    showBranch ? loadingBranch ? (
                                        <div className='fv-row mb-7'>
                                            <div className='d-flex flex-center'>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='fv-row mb-7'>
                                            <label className='required fw-semibold fs-6 mb-2'>Branch</label>
                                            <select onChange={handleChangeBranch} defaultValue={selectedBranch} name='branch_id' className='form-select form-select-solid form-select-lg fw-semibold'>
                                                {
                                                    branches.map((item: any) => <option key={item.id} value={item.id} >{item.name}</option>)
                                                }

                                            </select>
                                        </div>
                                    ) : null
                                }

                                {
                                    showDeptt ? loadingDeptt ? (
                                        <div className='fv-row mb-7'>
                                            <div className='d-flex flex-center'>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                                <span className="spinner-grow text-dark mx-2"></span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='fv-row mb-7'>
                                            <label className='required fw-semibold fs-6 mb-2'>Department</label>
                                            <select onChange={handleChange} defaultValue={selectedDeptt} name='department_id' className='form-select form-select-solid form-select-lg fw-semibold'>
                                                {
                                                    departments.map((item: any) => <option key={item.id} value={item.id} >{item.name}</option>)
                                                }

                                            </select>
                                        </div>
                                    ) : null
                                }


                                {showError ? <div className='form-text text-danger'>{errMsg}</div> : null}


                                <button
                                    type='reset'
                                    onClick={() => toggleShow(0)}
                                    className='btn btn-light me-3'
                                    data-kt-users-modal-action='cancel'
                                >
                                    Discard
                                </button>

                                <button
                                    type='submit'
                                    className='btn btn-primary'
                                    data-kt-users-modal-action='submit'
                                    disabled={isSubmitting}>
                                    <span className='indicator-label'>{isUpdate ? 'Update' : 'Save'}</span>
                                </button>
                            </div>
                            {/* end::Modal body */}
                        </div>
                        {/* end::Modal content */}
                    </div>
                    {/* end::Modal dialog */}
                </form>
            </div>
            {/* begin::Modal Backdrop */}
            <div className='modal-backdrop fade show'></div>
            {/* end::Modal Backdrop */}
        </>
    )
}

export { UserAddModal }
